import React from 'react';
import styled from 'styled-components';
import { BlockLayout, blockLayoutInnerProps } from '../../blockLayouts/Base';
import { BlockInfo } from '../../blocks/BlockInfo';
import { Body } from '../../components/Base';
import { InfoBlockLayoutProps } from '../Info/InfoLayout';

export const PostContentBlockLayout = (props: InfoBlockLayoutProps): JSX.Element => {
  const innerProps = blockLayoutInnerProps(props);
  const bodyMaxColumns = props.blocks[0]?.bodyMaxColumns ?? props.blockBodyMaxColumns;

  return (
    <StyledBlockLayout {...props} bodyMaxColumns={bodyMaxColumns}>
      <BlockInfo {...innerProps} block={props.blocks[0]} />
      <SpacerBottom />
    </StyledBlockLayout>
  );
};

const FallbackMaxColumns = 1;

const StyledBlockLayout = styled(BlockLayout)<{ bodyMaxColumns?: number }>`
  ${Body} {
    column-count: ${(props) => props.bodyMaxColumns ?? FallbackMaxColumns};
    column-width: max(calc(var(--unit-length) * 7), 300px);
    column-gap: var(--unit-length);
    width: 100%;
  }
`;

const SpacerBottom = styled.div`
  width: 100%;
  height: max(45px, var(--unit-length));
`;
